<template>
  <div>
    <div class="no-card" v-if="!valid">
      <h1 class="" />
      <div class="content-box" >
        <div class="m-2 text-center">
          <font-awesome-icon
            :icon="['fa', 'circle-notch']"
            class="fa-spin m-auto spinner fa-5x egx-partner-color"
          />
        </div>
      </div>
    </div>
    <ApplicationShow :step-num="step" :mode="mode" v-else/>
  </div>
</template>

<script>
import ApplicationShow from '../components/ApplicationShow.vue';

export default {
  components: {
    ApplicationShow
  },
  data() {
    return {
      step: 0,
      valid: false,
      mode: null,
    };
  },

  created() {
    if(!this.$route.query.tid && !this.$route.query.RESERVTKN) {
      this.$store.dispatch('buildings/getAll').then(() => {
        this.valid = true;
      });
      return;
    }

    const params = {
      project_id: this.$route.params.id,
      tid: this.$route.query.tid || this.$route.query.RESERVTKN,
    };

    this.mode = this.$route.query.mode;

    this.$store.dispatch('auth/signOut');
    this.$store.dispatch('fulfill_integrate/validateToken', params)
      .then(() => {
        console.log('Token validated successfully');
        this.$store.dispatch('buildings/getAll').then(() => {
          this.valid = true;
        });
      })
      .catch((error) => {
        this.$notify({
          group: 'notice-stay',
          type: 'error',
          text: error.details.result.error_message,
        });
        console.error(error);
        this.$router.push('/?errorPersist=true');
      })
  },

  computed: {
    settings() {
      return this.$store.state.partners.currentPartner.settings;
    },

    fulfillSyncDetails() {
      return this.settings.fulfill_sync_details;
    },
  },
}
</script>
